<template>
    <div
        v-if="isModeTest"
        class="test-sandbox"
    >
        <button
            v-show="!isVisible"
            ref="sandboxButton"
            class="test-sandbox__button"
            @click="isVisible = !isVisible"
        >
            Choose page
        </button>
        <List
            v-show="isVisible"
            v-closable="{
                exclude: ['sandboxButton'],
                handler: 'onClose'
            }"
            class="test-sandbox__list"
            :list="testLinks"
        >
            <template #item="{ item }">
                <ListItem
                    :key="item.name"
                    class="test-sandbox__box"
                >
                    <span class="test-sandbox__name">
                        {{ item.name }}
                    </span>
                    <NuxtLink
                        class="test-sandbox__link"
                        :title="item.name"
                        :to="`${cutHostPart(item.path)}/?mode=test`"
                    >
                        {{ cutHostPart(item.path) }}
                    </NuxtLink>
                </ListItem>
            </template>
        </List>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { rma, goodhome, salesUrl } from '~/src/config/pagesUrl';
import cutHostPart from '~/assets/utils/url/cutHostPart';
import List from '../../../components/common/List/index';
import ListItem from '../../../components/common/List/components/ListItem';

const {
    success: rmaSuccess,
    processing: rmaProcessing,
    confirmation: rmaConfirmation,
    create: rmaCreate,
} = rma;

const {
    application: goodhomeApplication,
    successPage: goodhomeSuccessPage,
} = goodhome;

const {
    salesOrderView,
} = salesUrl;

export default {
    name: 'TestSandbox',
    components: { ListItem, List },
    data() {
        return {
            isVisible: false,
            testLinks: [
                {
                    path: `${rmaCreate}/0`,
                    name: 'Rma create',
                },
                {
                    path: rmaConfirmation,
                    name: 'Rma confirmation',
                },
                {
                    path: rmaSuccess,
                    name: 'Rma success',
                },
                {
                    path: `${rmaProcessing}/0`,
                    name: 'Rma processing',
                },
                {
                    path: goodhomeSuccessPage,
                    name: 'Goodhome success page',
                },
                {
                    path: goodhomeApplication,
                    name: 'Goodhome form',
                },
                {
                    path: '/koszyk',
                    name: 'Cart',
                },
                {
                    path: `${salesOrderView}0`,
                    name: 'Order view',
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['isModeTest']),
    },
    methods: {
        cutHostPart,
        onClose() {
            this.isVisible = false;
        },
    },
};
</script>

<style lang="scss">
    .test-sandbox {
        padding: $spacing-small;
        background: $color-slate5;
        color: $color-slate100;
        display: flex;
        flex-flow: row wrap;
        z-index: 10000;
        font: $font-weight-light 14px/14px $goodHomeFontFamily;
        position: fixed;
        bottom: 0;
        right: 0;
        max-width: 100vw;
        max-height: 100vh;
        overflow: auto;

        &__box {
            flex: 1 1 100%;
            padding: $spacing-small 0;
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid $color-slate10;
        }

        &__name{
            font-weight: $font-weight-bold;
        }

        &__link {
            color: $color-slate100;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &__list {
            padding: $spacing-small;
            overflow: hidden;
        }
    }
</style>
